<div class="form-group row app-control-row sm-flex sm-cursor-grab sm-flex-row">
  <cc-template-field-actions
    [field]="model"
    [fieldActionsConfig]="fieldActionsConfig"
    [fieldSettingsActions]="fieldSettingsActions"
    [disabled]="hasReachedPlanLimit"
  ></cc-template-field-actions>

  <div class="app-control-label form-inline form-group">
    <div class="inline-block mr-2">
      <button type="button" class="btn btn-secondary app-control-dropdown">
        <i class="cc-icon cc-icon-user"></i>
      </button>
    </div>
    <input type="text" class="form-control no-drag" [(ngModel)]="model.description" />
  </div>
  <div class="sm-flex sm-items-center sm-gap-2 sm-p-2">
    <ng-select
      [readonly]="true"
      [class.disabled]="true"
      class="dropdown-selector sm-w-fit sm-min-w-2"
      name="personSelector"
      [placeholder]="'Select...'"
    >
    </ng-select>
    <cc-banner localStorageKey="person-field-beta-banner" type="warning" *ngIf="isPaidUser">
      <div class="sm-flex sm-items-center sm-gap-1">
        <p i18n class="cc-btn-subtle-blue-helper sm-px-1 sm-py-0.4">Beta</p>
        <p>Person field is not available on the Mobile Apps yet.</p>
      </div>
    </cc-banner>
  </div>
</div>
